import Links from '@/shared/constants/navegacao';
import { Link } from 'react-router-dom';

export default function Rodape() {
  return (
    <footer className="footer d-print-none d-flex justify-content-between align-items-center flex-wrap">
      <h2 className="text-center mx-auto">
        Coordenadoria de Desenvolvimento de Sistemas &copy;{' '}
        {new Date().getFullYear()} Defensoria Pública de Sergipe.
      </h2>
      <Link className="text-muted" to={Links.ChangeLog}>
        <span className="text-muted">v26.03.20</span>
      </Link>
    </footer>
  );
}
